async function api(path, options = {}) {
  const response = await fetch(path, options);
  const isJson = response.headers.get('Content-Type')?.includes('application/json');
  const payload = isJson ? await response.json().catch(() => ({})) : {};
  if (!response.ok) throw new Error(payload.error || `App API returned HTTP ${response.status}`);
  if (!isJson) throw new Error('App backend is unavailable in this preview.');
  return payload;
}

export async function uploadAsset(file, kind, intentId) {
  const body = new FormData();
  body.append('file', file);
  body.append('kind', kind);
  body.append('intentId', intentId);
  return api('/api/assets', {method: 'POST', body});
}

export function createPublishIntent() {
  return api('/api/intents', {method: 'POST'});
}

export function prepareStorefrontCatalog() {
  return api('/api/storefront-catalog', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({action: 'prepare'}),
  });
}

export function executeStorefrontCatalog(intentId) {
  return api('/api/storefront-catalog', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({action: 'execute', intentId}),
  });
}

export async function runCatalogProductOperation(type, payload) {
  const prepared = await api('/api/catalog-products', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({action: 'prepare', type, ...payload}),
  });
  return api('/api/catalog-products', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      action: 'execute', type, ...payload, intentId: prepared.authorization.intentId,
    }),
  });
}

export function saveProductMapping(mapping) {
  return api('/api/products', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(mapping),
  });
}

export function loadFulfillments() {
  return api('/api/fulfillments');
}

export function updateFulfillment(action, values) {
  return api('/api/fulfillments', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({action, ...values}),
  });
}

export function loadIntegrationStatus() {
  return api('/api/health');
}

export function loadPrintifyApparelRoutes() {
  return api('/api/printify');
}

export function loadPrintifyListingBatch(batchId) {
  return api(`/api/printify?batchId=${encodeURIComponent(batchId)}`);
}

export function createPrintifyApparelDrafts(input) {
  return runPrintifyProviderMutation('create-apparel-drafts', input);
}

export function capturePrintifyBatchMaster(input) {
  return api('/api/printify', {
    method: 'POST', headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({action: 'capture-batch-master', ...input}),
  });
}

export function createPrintifyDraftsFromMasters(input) {
  return runPrintifyProviderMutation('create-drafts-from-masters', input);
}

export function generatePrintifyBatchMetadata(input) {
  return runPrintifyProviderMutation('generate-batch-metadata', input);
}

export async function publishPrintifyApparelDrafts(input) {
  const prepared = await api('/api/printify', {
    method: 'POST', headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({action: 'prepare-publish-apparel-drafts', ...input}),
  });
  return api('/api/printify', {
    method: 'POST', headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({
      action: 'publish-apparel-drafts', ...input, intentId: prepared.authorization.intentId,
    }),
  });
}

export function importPrintifyBatchMetadata(input) {
  return api('/api/printify', {
    method: 'POST', headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({action: 'import-batch-metadata', ...input}),
  });
}

export function savePrintifyBatchMetadata(input) {
  return api('/api/printify', {
    method: 'POST', headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({action: 'save-batch-metadata', ...input}),
  });
}

export function applyPrintifyBatchMetadata(input) {
  return runPrintifyProviderMutation('apply-batch-metadata', input);
}

async function runPrintifyProviderMutation(action, input) {
  const prepared = await api('/api/printify', {
    method: 'POST', headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({...input, action: 'prepare-provider-mutation', targetAction: action}),
  });
  return api('/api/printify', {
    method: 'POST', headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({...input, action, intentId: prepared.authorization.intentId}),
  });
}
